'use client';

import { useTranslations, useLocale } from 'next-intl';
import { useScrollAnimation } from '@/hooks/use-scroll-animation';
import { SectionWrapper } from '@/components/ui/section-wrapper';
import { SectionHeading } from '@/components/frontend/home/section-heading';
import { ModulesGrid } from '@/components/frontend/modules/modules-grid';
import { Button } from '@/components/ui/button';
import { getLocalizedPath, getLocalizedPagePath } from '@/lib/locale-utils';

type ModuleItem = { id: string; title: string; description: string; image?: string | null };

export function HomeModules({ initialModules }: { initialModules?: ModuleItem[] }) {
  const t = useTranslations('home.networkTools');
  const sectionRef = useScrollAnimation({ threshold: 0.15 });
  const locale = useLocale();

  return (
    <SectionWrapper
      ref={sectionRef.ref}
      variant="default"
      padding="md"
      className="relative overflow-hidden !bg-transparent  after:content-[''] after:absolute after:inset-0 after:bg-[url('/images/home/MLM-Business.webp')] after:bg-cover after:bg-center after:-z-10 after:opacity-100 dark:after:opacity-0"
    >
      <div className="relative z-10">
        <SectionHeading
          pill={t('pillLabel')}
          title={t('title')}
          subtitle={t('subtitle')}
          isVisible={sectionRef.isVisible}
        />

        <ModulesGrid limit={6} showOnHomePageOnly={true} initialModules={initialModules} />

        <div className="mt-10 flex justify-center">
          <Button
            href={getLocalizedPagePath('mlm-software-modules', locale)}
            variant="outline"
            size="lg" className="w-full sm:w-auto justify-center"
            showArrow
          >
            {t('exploreAllModules')}
          </Button>
        </div>
      </div>
    </SectionWrapper>
  );
}
